import { ReactNode } from 'react';
import clsx from 'clsx';

interface Props {
	children: ReactNode;
	className?: string;
}

export const ContainerBase1: React.FC<Props> = ({ className, children }) => {
	return <div className={clsx('w-full min-h-full', className)}>{children}</div>;
};
